import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import Home from "./pages/Home";
import Tarifs from "./pages/Tarifs";
import Fasciatherapie from "./pages/Fasciatherapie";
import Coaching from "./pages/Coaching";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import BlogArticle from "./pages/BlogArticle";
import MentionsLegales from "./pages/MentionsLegales";
import SpecialtyPage from "./pages/SpecialtyPage";
import CityPage from "./pages/CityPage";
import Layout from "./components/Layout";
import { FASCIA_SPECIALTIES, COACHING_SPECIALTIES, CITIES } from "./data/specialties";
import { fasciaUrl, coachUrl, cityUrl, urlSlugToCoachSlug } from "./data/urls";

// Legacy redirect components: preserve SEO from old URLs (/villes/:ville, /fasciatherapie/:slug, /coach-sportif/:slug)
function LegacyCityRedirect() {
  const { ville } = useParams();
  return <Navigate to={cityUrl(ville)} replace />;
}
function LegacyFasciaRedirect() {
  const { slug } = useParams();
  return <Navigate to={fasciaUrl(slug)} replace />;
}
function LegacyCoachRedirect() {
  const { slug } = useParams();
  // Redirect legacy /coach-sportif/senior → /coach-sportif-senior-toulouse (in case someone had short URL)
  const dataSlug = urlSlugToCoachSlug(slug);
  return <Navigate to={coachUrl(dataSlug)} replace />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />

            {/* Original site URLs — preserved intact */}
            <Route path="/fasciathérapie-toulouse" element={<Fasciatherapie />} />
            <Route path="/coach-domicile" element={<Coaching />} />
            <Route path="/tarifs" element={<Tarifs />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
            <Route path="/mentions-légales" element={<MentionsLegales />} />
            <Route path="/contact" element={<Contact />} />

            {/* New SEO-optimized city landing pages */}
            {CITIES.map((c) => (
              <Route
                key={c.slug}
                path={cityUrl(c.slug)}
                element={<CityPage slug={c.slug} />}
              />
            ))}

            {/* New SEO-optimized fasciathérapie specialty pages */}
            {FASCIA_SPECIALTIES.map((s) => (
              <Route
                key={`f-${s.slug}`}
                path={fasciaUrl(s.slug)}
                element={<SpecialtyPage service="fasciatherapie" slug={s.slug} />}
              />
            ))}

            {/* New SEO-optimized coach sportif specialty pages */}
            {COACHING_SPECIALTIES.map((s) => (
              <Route
                key={`c-${s.slug}`}
                path={coachUrl(s.slug)}
                element={<SpecialtyPage service="coaching" slug={s.slug} />}
              />
            ))}

            {/* Legacy redirects (301) — keep old URLs working for SEO continuity */}
            <Route path="/villes/:ville" element={<LegacyCityRedirect />} />
            <Route path="/fasciatherapie/:slug" element={<LegacyFasciaRedirect />} />
            <Route path="/coach-sportif/:slug" element={<LegacyCoachRedirect />} />
            <Route path="/fasciatherapie" element={<Navigate to="/fasciathérapie-toulouse" replace />} />
            <Route path="/coaching" element={<Navigate to="/coach-domicile" replace />} />
            <Route path="/mentions-legales" element={<Navigate to="/mentions-légales" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
